/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DocTextIcon16Light } from './DocTextIcon16Light';
import { DocTextIcon16Regular } from './DocTextIcon16Regular';
import { DocTextIcon16Solid } from './DocTextIcon16Solid';
import { DocTextIcon20Light } from './DocTextIcon20Light';
import { DocTextIcon20Regular } from './DocTextIcon20Regular';
import { DocTextIcon20Solid } from './DocTextIcon20Solid';
import { DocTextIcon24Regular } from './DocTextIcon24Regular';
import { DocTextIcon24Solid } from './DocTextIcon24Solid';
import { DocTextIcon32Regular } from './DocTextIcon32Regular';
import { DocTextIcon64Regular } from './DocTextIcon64Regular';
var sizes = {
    16: {
        light: DocTextIcon16Light,
        regular: DocTextIcon16Regular,
        solid: DocTextIcon16Solid,
    },
    20: {
        light: DocTextIcon20Light,
        regular: DocTextIcon20Regular,
        solid: DocTextIcon20Solid,
    },
    24: {
        regular: DocTextIcon24Regular,
        solid: DocTextIcon24Solid,
    },
    32: {
        regular: DocTextIcon32Regular,
    },
    64: {
        regular: DocTextIcon64Regular,
    },
};
export var DocTextIcon = forwardRef('DocTextIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
